import React, { useContext, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@emotion/react';
import PageHolder from 'app/lib/pageHolder';
import MainPage from 'pages/mainPage';
import RedirectWrapper from 'app/lib/redirectWrapper/redirectWrapper';
import LoginPage from 'pages/loginPage/loginPage';
import ExplorerPage from 'pages/explorerPage/explorerPage';
import LoaderWrapper from 'app/lib/loaderWrapper';
import UploadPage from 'pages/uploadPage/uploadPage';
import UiContextProvider from 'shared/lib/contexts/uiContextProvider';
import ProfilePage from 'pages/profilePage/profilePage';
import TrashPage from 'pages/trash/trashPage';
import SearchPage from 'pages/searchPage/searchPage';
import TrashExplorerPage from 'pages/trashExplorerPage/trashExplorerPage';
import AdminPage from 'pages/adminPages/adminPage';
import { usePingAdminRequests } from 'app/hooks/usePingAdminRequests';
import RegistrationPage from 'pages/loginPage/registrationPage';
import RestorePage from 'pages/loginPage/restorePage';

export default observer(function App() {
  const {
    mobxStore: { uiStore, authStore, sectionStore },
  } = useContext(MobxContext);

  const { mobxStore } = useContext(MobxContext);
  const currentTheme = uiStore.currentThemeVariant;
  usePingAdminRequests();

  const isAuth = authStore.isAuth;
  useEffect(() => {
    if (!isAuth) {
      return;
    }
    authStore.getMe();
  }, [isAuth, authStore]);

  const { sections, isPending, isError } = sectionStore;
  useEffect(() => {
    if (sections === null && !isPending && !isError && isAuth) {
      sectionStore.fetchBulk();
    }
  }, [sections, isPending, isError, sectionStore, isAuth]);

  return (
    <ThemeProvider theme={currentTheme}>
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              <RedirectWrapper>
                <LoaderWrapper>
                  <UiContextProvider>
                    <LoginPage />
                  </UiContextProvider>
                </LoaderWrapper>
              </RedirectWrapper>
            }
          ></Route>
          <Route
            path="/signup"
            element={
              <RedirectWrapper>
                <LoaderWrapper>
                  <UiContextProvider>
                    <RegistrationPage />
                  </UiContextProvider>
                </LoaderWrapper>
              </RedirectWrapper>
            }
          ></Route>
          <Route
            path="/password_recover"
            element={
              <RedirectWrapper>
                <LoaderWrapper>
                  <UiContextProvider>
                    <RestorePage />
                  </UiContextProvider>
                </LoaderWrapper>
              </RedirectWrapper>
            }
          ></Route>
          <Route
            path="/"
            element={
              <RedirectWrapper>
                <LoaderWrapper>
                  <UiContextProvider>
                    <PageHolder>
                      <MainPage />
                    </PageHolder>
                  </UiContextProvider>
                </LoaderWrapper>
              </RedirectWrapper>
            }
          ></Route>
          <Route
            path="/profile"
            element={
              <RedirectWrapper>
                <LoaderWrapper>
                  <UiContextProvider>
                    <PageHolder>
                      <ProfilePage />
                    </PageHolder>
                  </UiContextProvider>
                </LoaderWrapper>
              </RedirectWrapper>
            }
          ></Route>
          <Route
            path="/explorer"
            element={
              <RedirectWrapper>
                <LoaderWrapper>
                  <UiContextProvider>
                    <PageHolder>
                      <ExplorerPage key={mobxStore.explorerPageKey} />
                    </PageHolder>
                  </UiContextProvider>
                </LoaderWrapper>
              </RedirectWrapper>
            }
          ></Route>
          <Route
            path="/upload"
            element={
              <RedirectWrapper>
                <LoaderWrapper>
                  <UiContextProvider>
                    <PageHolder>
                      <UploadPage />
                    </PageHolder>
                  </UiContextProvider>
                </LoaderWrapper>
              </RedirectWrapper>
            }
          ></Route>
          <Route
            path="/search"
            element={
              <RedirectWrapper>
                <LoaderWrapper>
                  <UiContextProvider>
                    <PageHolder>
                      <SearchPage />
                    </PageHolder>
                  </UiContextProvider>
                </LoaderWrapper>
              </RedirectWrapper>
            }
          ></Route>
          <Route
            path="/trash"
            element={
              <RedirectWrapper>
                <LoaderWrapper>
                  <UiContextProvider>
                    <PageHolder>
                      <TrashPage />
                    </PageHolder>
                  </UiContextProvider>
                </LoaderWrapper>
              </RedirectWrapper>
            }
          ></Route>
          <Route
            path="/trash_explorer"
            element={
              <RedirectWrapper>
                <LoaderWrapper>
                  <UiContextProvider>
                    <PageHolder>
                      <TrashExplorerPage />
                    </PageHolder>
                  </UiContextProvider>
                </LoaderWrapper>
              </RedirectWrapper>
            }
          ></Route>
          <Route
            path="/admin"
            element={
              <RedirectWrapper>
                <LoaderWrapper>
                  <UiContextProvider>
                    <PageHolder>
                      <AdminPage />
                    </PageHolder>
                  </UiContextProvider>
                </LoaderWrapper>
              </RedirectWrapper>
            }
          ></Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
});
